module.exports = __webpack_public_path__ + "static/media/login-active.55e084e5.svg";